"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversionHandler = void 0;
var ConversionHandler = /** @class */ (function () {
    function ConversionHandler(zeroValue, logger) {
        var handlers = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            handlers[_i - 2] = arguments[_i];
        }
        var _this = this;
        this.zeroValue = zeroValue;
        this.handlers = [];
        this.logger = logger;
        handlers.forEach(function (handler) { return _this.addHandler(handler); });
    }
    ConversionHandler.prototype.addHandler = function (handler) {
        this.handlers.push(handler);
    };
    ConversionHandler.prototype.convert = function (message) {
        return this.handlers.reduce(function (value, handler) { return handler(message, value); }, this.zeroValue());
    };
    return ConversionHandler;
}());
exports.ConversionHandler = ConversionHandler;
